// @flow

import useEnabledFeature from '../../useEnabledFeature/useEnabledFeature';

const useBRVintage = (): boolean => {
  return useEnabledFeature('cat-br-vintage');
};

export default useBRVintage;
